module.exports = __webpack_public_path__ + "img/iq.2079b33a.svg";